import { useContext } from 'react';
import { StepValidationContext } from '../../contexts/step-validation/StepValidationContext';

export const useStepValidation = () => {
    const context = useContext(StepValidationContext);
    if (!context) {
        throw new Error('useStepValidation must be used within a StepValidationProvider');
    }
    return context;
};
